import React, { Component } from 'react';
import styled from 'styled-components';
import { LoadingSpinnerPage } from '../../../components/atomic/Loaders/LoadingSpinner';
import Wizard from '../../../layouts/Wizard';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as apiServices from '../../../services/apiServices';
import Body from './Body';
import { Exercise, ExerciseForm } from '../../../core/model';
import { getResources } from '../../../modules/Resource';
import { formBase, isSubmitted, setForm, submitExerciseForm } from '../../../modules/ExerciseForm';
import { formatDataToModel } from '../../../utils';
import { toast } from 'react-toastify';

const Container = styled.div`

`
class Form extends Component {
  constructor(props) {
    super(props);
    this.submitQueue = [];
    this.state = {
      currentExercise: null,
      exercises: [],
      isLoading: true,
      modsLoading: false,
      submitted: false,
    };
  }

  async componentWillMount() {
    const { data } = this.props;
    this.retrieveExercise(data);
  }

  async componentWillReceiveProps(nextProps) {
    const { data } = nextProps
    this.retrieveExercise(data);
  }

  retrieveExercise = async data => {
    try {
      const currentExercise = formatDataToModel(data, Exercise);
      this.setState({
        currentExercise,
        isLoading: false,
      });
    } catch(e) {
      console.log('component: ',this,e.message);
      toast.error(e.message);
    }
  }

  setSubmitQueue = (form, primaryExercise = false) => {
    const { formBase, updateExercise, isSubmitted } = this.props;
    const uid = form.id;
    const submitIndex = this.submitQueue.push(false) - 1;
    apiServices.updateExercise(uid, form.formatforDB())
    .then(response => {
      this.submitQueue[submitIndex] = true;
      if(!this.submitQueue.includes(false)) {
        formBase();
      } else {
        this.setState({ submitted: true })
        isSubmitted();
      }
      if(primaryExercise) {
        updateExercise(form);
      }
    })
    .catch(e => {
      formBase();
      console.log('component: ',this,e);
      toast.error(
        e.response.data.ValidationError ? e.response.data.ValidationError : e.message
      );
    })
  }

  getInistialValues = obj => {
    const base = {
      name: '',
      equipment: [],
      categories: [],
      musclegroup: [],
      tags: [],
      explanation: [],
      video: [],
    }
    return Object.assign(obj, base);
  }

  updateForm = form => {
    const { setForm } = this.props;
    setForm(form);
  }

  render() {
    const { resourceState } = this.props;
    const { currentExercise, isLoading, submitted } = this.state;
    const exForm = new ExerciseForm();
    if(currentExercise) {
      exForm.formatForForm(currentExercise);
    }
    return isLoading ? (
      <LoadingSpinnerPage/>
    ) : (
      <Container>
        <Body
          key={`exercise-${exForm.id}`}
          initialValues={exForm}
          options={resourceState.resourceData}
          submit={(form) => this.setSubmitQueue(form, true)}
          submissionComplete={submitted}
          updateForm={this.updateForm}
        />
      </Container>
    )
  }
}

Form.propTypes = {

};

Form.defaultProps = {
  
};


function mapFormStateToProps(state) {
  return {
    resourceState: state.resourceState
  };
}

function mapFormDispatchToProps(dispatch) {
  return bindActionCreators({
    getResources: getResources,
    formBase: formBase,
    isSubmitted: isSubmitted,
    setForm: setForm
  }, dispatch)
}

const NewForm = connect(mapFormStateToProps,mapFormDispatchToProps)(Form);

class ExerciseFormWizard extends Component {
  constructor(props) {
    super(props);
    this.state = {

    }
  }

  save = () => {
    const { submitExerciseForm } = this.props;

    submitExerciseForm();
  }

  cancel = () => {
    const { close } = this.props;
    if(close) {
      close();
    }
  }

  render(){
    const { exerciseFormState, ...other } = this.props;
    // const template = new Template();
    // if(classForm) {
    //   template.sets = classForm.sets;
    // }
    return (
      <Wizard
        clean={exerciseFormState.clean}
        onFinish={this.save}
        onCancel={this.cancel}
        saveText="Save Exercise"
        stepComponents={[
          {
            label: 'Create Class',
            component: <NewForm {...other}/>,
          },
        ]}
      />
    )
  }
}

function mapStateToProps(state) {
  return {
    exerciseFormState: state.exerciseFormState
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    getResources: getResources,
    formBase: formBase,
    isSubmitted: isSubmitted,
    submitExerciseForm: submitExerciseForm,
  }, dispatch)
}

export default connect(mapStateToProps,mapDispatchToProps)(ExerciseFormWizard);

